import { css } from "@emotion/react";

export const historyStyle = css`
  display: grid;
  grid-row-gap: 24px;
`;
